/**
 * Sugestões de bagagem (rodada 2, bloco B) — OPT-IN.
 *
 * Regra do PO: nunca uma lista pronta, nunca por destino. Isto é um
 * catálogo genérico, por categoria, que só aparece quando a pessoa toca em
 * "Sugestões", e cada item só entra na mala com um toque explícito. Nada
 * aqui sabe para onde a viagem vai.
 */
import type { BaggageCategory } from './baggage.js';

export const BAGGAGE_SUGGESTIONS: Record<BaggageCategory, readonly string[]> = {
  documentos: ['Passaporte', 'Documento com foto', 'Carteira de motorista', 'Cartões', 'Dinheiro em espécie', 'Seguro viagem', 'Reservas impressas', 'Cartão do plano de saúde'],
  roupas: ['Camisetas', 'Calças', 'Shorts', 'Roupa íntima', 'Meias', 'Pijama', 'Casaco leve', 'Casaco de frio', 'Capa de chuva', 'Tênis confortável', 'Chinelo', 'Boné ou chapéu', 'Óculos de sol', 'Roupa para sair à noite'],
  eletronicos: ['Carregador do celular', 'Carregador portátil', 'Adaptador de tomada', 'Fone de ouvido', 'Cabo extra', 'Câmera', 'Cartão de memória', 'Relógio'],
  higiene: ['Escova e pasta de dente', 'Desodorante', 'Shampoo e condicionador', 'Sabonete', 'Protetor solar', 'Hidratante', 'Escova de cabelo', 'Absorventes', 'Lâmina de barbear', 'Cortador de unha', 'Repelente'],
  medicamentos: ['Remédios de uso contínuo', 'Analgésico', 'Antitérmico', 'Antialérgico', 'Remédio para enjoo', 'Curativos', 'Termômetro', 'Receitas médicas'],
  criancas: ['Fraldas', 'Lenços umedecidos', 'Mamadeira', 'Lanches', 'Brinquedo favorito', 'Carrinho', 'Muda de roupa extra', 'Protetor solar infantil', 'Garrafinha de água'],
  praia: ['Roupa de banho', 'Toalha', 'Protetor solar', 'Óculos de natação', 'Boia', 'Saco impermeável', 'Sandália de água', 'Chapéu'],
  outros: ['Mochila pequena', 'Garrafa de água', 'Guarda-chuva', 'Cadeado', 'Sacola para roupa suja', 'Travesseiro de pescoço', 'Caneta', 'Lanche para a viagem'],
};

/** Normaliza para comparar com o que já está na lista. */
export function normalizeItemTitle(t: string): string {
  return t
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}
